/**
 * Labels of the in-app help (DESIGN UD-18): term and channel popovers, the Glossary view, the Help menu and the
 * keyboard-shortcuts dialog. The copy itself (glossary entries, channel explainers) lives in `strings-glossary.ts` and
 * `src/engine/channels/explain.ts`. No banned word (UX-WORD-01); plain, short, specific.
 */
import { SHIPPED_MODEL_ID, modelCardHrefFor } from '../shared/model-figures.ts';

export const HELP = {
	// popover
	measures: 'Measures',
	why: 'Why it matters',
	direction: 'Direction',
	humanCauses: 'Human causes too',
	needs: 'Needs',
	openChannel: 'Open channel',
	glossaryLink: 'Glossary',
	close: 'Close',
	directionHigher: 'Higher values are more machine-like',
	directionLower: 'Lower values are more machine-like',
	popoverLabel: (what: string) => `About ${what}`,

	// Help menu
	menu: 'Help',
	howToRead: 'How to read a result',
	glossary: 'Glossary',
	shortcuts: 'Keyboard shortcuts',
	userGuide: 'User guide',
	limitations: 'Limitations',
	modelCard: 'Model card',
	loadSample: 'Load the sample document',
	copyDiagnostics: 'Copy diagnostics',
	diagnosticsCopied: 'Diagnostics copied',
	diagnosticsCopyFailed: 'The diagnostics could not be copied.',

	// documents served with the app (copied from docs/ at build time)
	userGuideHref: '/docs/USER-GUIDE.md',
	limitationsHref: '/docs/LIMITATIONS.md',
	/** The shipped model's card; the Help menu follows the analysed result's model (`modelCardHrefFor`). */
	modelCardHref: modelCardHrefFor(SHIPPED_MODEL_ID),

	// shortcuts dialog
	shortcutsTitle: 'Keyboard shortcuts',
	shortcutsKey: 'Key',
	shortcutsAction: 'Action',
	shortcutsExtraKey: '?',
	shortcutsExtraAction: 'show this list',

	// glossary view
	glossaryTitle: 'Glossary',
	glossarySearch: 'Search the glossary',
	glossarySearchPlaceholder: 'Term or word',
	glossaryNone: 'No term matches.',
	glossaryChannels: 'Channels',
	glossaryChannelsIntro:
		'Each channel measures one habit of the text. All of them are shown separately; none is merged into another.',
	glossaryTerms: 'Terms',
	howToReadTitle: 'How to read a result',
	/** Three sentences: evidence, not a verdict; the interval; consider the opposite. */
	howToReadBody:
		'A result is evidence about how the text was written, not a decision about who wrote it. Read each channel with its interval: a wide interval means the text gave little to measure. Before you act on a reading, ask which ordinary human causes could produce the same pattern.',
	backToIntake: 'Back to the intake',
	landingLinks: 'Help',
} as const;
